import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { PARAMETER } from '../../../../../constants/parameter-name-for-update';
import InputValueProps from '../../../../../prop-types/input-value-props';
import DutiesAndTaxesDropdown from '../../../../../../../../fulfillment-planner/duties-and-taxes/dropdown';
import style from './style.module.less';
import messages from './messages';

const SetPrepayDutiesAndTaxes = ({ inputValueProps, onChange }) => {
  const { parameter: selectedValue } = inputValueProps;

  const onValueChange = useCallback(
    (value) => {
      onChange({
        [PARAMETER]: value,
      });
    },
    [onChange],
  );

  return (
    <div className={style['multi-control-row']}>
      <div>
        <FormattedMessage {...messages.serviceCollection} />
      </div>
      <DutiesAndTaxesDropdown onChange={onValueChange} selectedOptionValue={selectedValue} shouldHidePrice />
    </div>
  );
};

SetPrepayDutiesAndTaxes.propTypes = {
  inputValueProps: InputValueProps.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default SetPrepayDutiesAndTaxes;
